import { render, staticRenderFns } from "./OntologySummary.vue?vue&type=template&id=6bee2772&"
import script from "./OntologySummary.vue?vue&type=script&lang=ts&"
export * from "./OntologySummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports